<script lang="ts">
	import { Command as CommandPrimitive } from "bits-ui";
	import { cn } from "@ui-lib/utils/utils.js";

	let {
		ref = $bindable(null),
		value = $bindable(""),
		class: className,
		...restProps
	}: CommandPrimitive.RootProps = $props();
</script>

<CommandPrimitive.Root
	class={cn(
		"bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
		className
	)}
	bind:value
	bind:ref
	{...restProps}
/>
